import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import type { BlogSharedDataRawData } from '@/Shared/AutoGenerated/Main'

export default class BlogSharedData {
    constructor(
        public readonly appName: string,
        public readonly openCookieSettingsElementId: string,
    ) {
        ensureNoUndefinedProperties(this)
    }

    static hydrate(rawData: BlogSharedDataRawData): BlogSharedData {
        return new BlogSharedData(
            rawData.appName,
            rawData.openCookieSettingsElementId,
        )
    }

    getBlogLayoutProps() {
        return {
            appName: this.appName,
            openCookieSettingsElementId: this.openCookieSettingsElementId,
        }
    }
}
